export default __webpack_public_path__ + "static/media/twinstarProtectSpecial.88a46661.jpg";